<template>
  <vg-card>
    <vg-view-field-list class="no-hr">
      <dp-application-view-field
          :value="{attributeName: '验真时间', value: this.verifyTime}"
          label-width="120px"
          label-suffix="："
      />
      <dp-application-view-field
          v-for="(field, index) in sortedFields"
          :key="field.applicationAttributeFieldId"
          :value="field"
          label-width="120px"
          :bold-value="index < 3 || index < 1"
          label-suffix="："
      />
      <dp-application-view-field
          v-if="this.passCardType === 'TENANT_EMPLOYEE'"
          :value="{attributeName: '有效期至', value: expireTimeFilter(this.expireTime)}"
          label-width="120px"
          label-suffix="："
      />
      <dp-application-view-field
          v-if="this.verifyResult !== 'PASS'"
          :value="{attributeName: '失败原因', value: verifyResultMessage }"
          label-width="120px"
          label-suffix="："
      />
    </vg-view-field-list>
  </vg-card>
<!--  <div class="vg-content">-->
<!--    <div class="item">-->
<!--      <div class="item-entry" style="margin-top: 0px;">-->
<!--        <div class="item-title">验真时间：</div>-->
<!--        <div class="item-text">{{ this.verifyTime }}</div>-->
<!--      </div>-->
<!--      <div v-for="item in passCardApplicationResourceFieldList" :key="item.applicationAttributeFieldId">-->
<!--        <div class="item-entry" v-if="item.attributeType !== 'PERSONAL_PHOTO' && item.attributeType !== 'PROJECT_ID'-->
<!--              && item.attributeType !== 'PERSONAL_NAME'&& item.attributeType !== 'CONSTRUCTION_LOCATION'&& item.attributeType !== 'TENANT_COMPANY'-->
<!--              && item.attributeType !== 'ID_CARD_PHOTO_BACK' && item.attributeType !== 'ID_CARD_PHOTO_FRONT' && item.attributeType !== 'CONSTRUCTION_TYPE'">-->
<!--          <div class="item-title">{{ item.attributeName }}</div>-->
<!--          <div class="item-text" >{{ item.value }}</div>-->
<!--        </div>-->
<!--        <div class="item-entry" v-if="item.attributeType === 'PERSONAL_NAME' || item.attributeType === 'TENANT_COMPANY' || item.attributeType === 'CONSTRUCTION_LOCATION'">-->
<!--          <div class="item-title">{{ item.attributeName }}</div>-->
<!--          <div class="item-text" style="font-weight: bold;">{{ item.value }}</div>-->
<!--        </div>-->
<!--        -->
<!--        <div class="item-entry" v-if="item.attributeType === 'CONSTRUCTION_TYPE' ">-->
<!--          <div class="item-title">{{ item.attributeName }}</div>-->
<!--          <div class="item-text" v-if="item.value === 'CONSTRUCTION_SERVICE_PROVIDER'">物业服务商施工</div>-->
<!--          <div class="item-text" v-if="item.value === 'CONSTRUCTION_DECORATION'">装修单元施工</div>-->
<!--          <div class="item-text" v-if="item.value === 'CONSTRUCTION_OPERATIONS'">营运单元施工</div>-->
<!--        </div>-->
<!--        <div class="item-entry" v-if="item.attributeType === 'PROJECT_ID'">-->
<!--          <div class="item-title">{{ item.attributeName }}</div>-->
<!--          <div class="item-text">{{ item.value.projectName }}</div>-->
<!--        </div>-->
<!--        <div class="item-entry" v-if="item.attributeType === 'PERSONAL_PHOTO'">-->
<!--          <div class="item-title">人员照片：</div>-->
<!--          <van-image width="120" height="120" :src="item.value"/>-->
<!--        </div>-->
<!--      </div>-->
      <!-- <div class="item-entry">
        <div class="item-title">租户公司：</div>
        <div class="item-text" style="font-weight: bold;">每日优鲜有限责任公司1</div>
      </div>
      <div class="item-entry">
        <div class="item-title">手机号：</div>
        <div class="item-text">186****0530</div>
      </div>
      <div class="item-entry">
        <div class="item-title">身份证号：</div>
        <div class="item-text">430703********0556</div>
      </div> -->

      <!-- <div class="item-entry">
        <div class="item-title">项目：</div>
        <div class="item-text">上海来福士</div>
      </div>
      <div v-if="true">
        <div class="item-entry">
          <div class="item-title">施工类型：</div>
          <div class="item-text">长期</div>
        </div>
        <div class="item-entry">
          <div class="item-title">施工单位：</div>
          <div class="item-text">伟成装修施工有限责任公司</div>
        </div>
        <div class="item-entry">
          <div class="item-title">施工内容：</div>
          <div class="item-text">14-18、拆除</div>
        </div>
      </div> -->
<!--      <div class="item-entry" v-if="this.passCardType === 'TENANT_EMPLOYEE'">-->
<!--        <div class="item-title">有效期至：</div>-->
<!--        <div class="item-text">{{ this.expireTime }}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

</template>

<script>
import srcLogo from "@/assets/login/kaidelogo.png";
import {client} from "@/libraries/http";
import VgCard from "@/components/Commons/VgCard.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import DpApplicationViewField
  from "@/views/DigitalPassApplications/DigitalPassApplication/DpApplicationViewField/index.vue";
import verifyResultMessage from "@/filters/verifyResultMessage";
import expireTime from "@/filters/expireTime";

export default {
  name: "VerifyRecordDetail",
  components: {
    DpApplicationViewField,
    VgViewFieldList,
    VgCard
  },
  data() {
    return {
      srcLogo: srcLogo,
      id: "",
      passCardApplicationResourceFieldList: undefined,
      expireTime: undefined,
      verifyTime: undefined,
      passCardType: undefined,

      verifyResult: null
    }
  },
  computed: {
    verifyResultMessage() {
      return verifyResultMessage(this.verifyResult)
    },
    sortedFields() {
      const fields = this.passCardApplicationResourceFieldList || [];
      const orderMap = {
        'PERSONAL_NAME': 1,
        'CONSTRUCTION_LOCATION': 2,
        'TENANT_COMPANY': 3,
        'BRAND': 4,
        'PHONE_NUMBER': 5,
        'PERSONAL_PHOTO': 6,
        'PROJECT_ID': 7,
        'CONSTRUCTION_TYPE': 8,
        'CONSTRUCTOR': 9,
        'CONSTRUCTION_CONTENT': 10,
        'CONSTRUCTION_START_TIME': 11,
        'CONSTRUCTION_END_TIME': 12,
        // 'ID_CARD_PHOTO_FRONT': 12,
        // 'ID_CARD_PHOTO_BACK': 13,
        // 'TP_OVERTIME_APPROVAL_PHOTO': 14,
      }

      return fields.filter(field => orderMap[field.attributeType])
          .sort((l, r) => {
            return orderMap[l.attributeType] - orderMap[r.attributeType]
          })
    }
  },
  mounted() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    expireTimeFilter(value) {
      return expireTime(value)
    },
    getDetail() {
      client.get("/api/h5/guard/verify/detail/" + this.id).then(res => {
        console.log(res);
        this.passCardApplicationResourceFieldList = res.data.passCardApplicationResourceFieldList;
        this.expireTime = res.data.expireTime;
        this.verifyTime = res.data.verifyTime;
        this.passCardType = res.data.passCardType;
        this.verifyResult = res.data.verifyResult;
      })
    },
  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
}

.item {
  width: auto;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 80px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #000000;
}

</style>
